import { Grid, useMediaQuery } from "@mui/material";
import logo from "../images/logo.svg";
import facebook from "../images/icon-facebook.svg";
import youtube from "../images/icon-youtube.svg";
import twitter from "../images/icon-twitter.svg";
import pinterest from "../images/icon-pinterest.svg";
import instagram from "../images/icon-instagram.svg";
import { BrowserRouter as Link } from "react-router-dom";
import SvgComponent from "./icons/FacebookIcon";
const Footer = () => {
  const matches = useMediaQuery("(min-width:480px)");
  const matches2 = useMediaQuery("(max-width:1189px)");
  const style = {
    padding: "5rem 11rem 5rem 10rem ",
    backgroundColor: "hsl(233, 26%, 24%)",
    position: "relative",
    display: "flex",
    flex: "row",
    justifyContent: "space-between",
  };
  const styleM = {
    padding: "5rem 1rem 5rem ",
    backgroundColor: "hsl(233, 26%, 24%)",
    textAlign: "center",
  };

  return (
    <div style={matches ? style : styleM}>
      {/* <div className="footer">
        <div className="footer-icons">
          <img src={logo} />
          <div className="footer-socials">
            <img src={facebook} />
            <img src={youtube} />
            <img src={twitter} />
            <img src={pinterest} />
            <img src={instagram} />
          </div>
        </div>
        <div className="footer-links">
          <br />
          <br />
          <Link className="footer-link">About Us</Link>
          <br />
          <br />

          <Link className="footer-link">Contact</Link>
          <br />
          <br />
          <Link className="footer-link">Blog</Link>
          <br />
          <br />
        </div>
        <div>
          {" "}
          <Link className="footer-link">Careers</Link>
          <br />
          <br />
          <Link className="footer-link">Support</Link>
          <br />
          <br />
          <Link className="footer-link">Privacy Policy</Link>
          <br />
          <br />
        </div>
        <div style={matches ? { marginLeft: "16rem" } : { marginLeft: 0 }}>
          {" "}
          <button>Request Invite</button>
          <br />
          <br />
          <p>© Easybank. All Rights Reserved</p>
        </div>
      </div> */}
      <SvgComponent />
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3, lg: 6 }}
      >
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <Grid item>
            <img src={logo} style={{ marginBottom: "2rem" }} />
            <Grid container>
              <Grid item xs={2.4}>
                <img src={facebook} />
              </Grid>
              <Grid item xs={2.4}>
                <img src={youtube} />
              </Grid>
              <Grid item xs={2.4}>
                <img src={twitter} />
              </Grid>
              <Grid item xs={2.4}>
                <img src={pinterest} />
              </Grid>
              <Grid item xs={2.4}>
                <img src={instagram} />
              </Grid>
              <br />
              <br />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <Link className="footer-link">About Us</Link>
          <br />
          <br />
          <Link className="footer-link">Contact</Link>
          <br />
          <br />
          <Link className="footer-link">Blog</Link>
          <br />
          <br />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <Link className="footer-link">Careers</Link>
          <br />
          <br />
          <Link className="footer-link">Support</Link>
          <br />
          <br />
          <Link className="footer-link">Privacy Policy</Link>
          <br />
          <br />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={6}>
          <div
            style={matches2 ? { marginLeft: 0 } : { marginLeft: "59%" }}
            className="footer-btn"
          >
            <button>Request Invite</button>
            <br />
            <br />
            <p style={{ fontSize: "14px" }}>© Easybank. All Rights Reserved</p>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Footer;
